<template>
  <div
    class="profile-link"
    @mouseenter="hovered = true"
    @mouseleave="hovered = false"
  >
    <v-card
      :to="{ name: isHrisProfile ? 'job-profile-hris-view' : 'job-profile-view', params: { id: profile.ulid } }"
      variant="outlined"
      rounded="lg"
      class="pa-3"
    >
      <p class="text-body-3 text-textLight mb-1">
        <template v-if="isHrisProfile">
          Workday profile:
        </template>
        <span class="text-body-2 font-weight-medium text-textDarkest ml-1">
          {{ profile.title }}
        </span>
      </p>
      <v-sheet
        :min-height="32"
        class="d-flex ga-4"
      >
        <JobProfileStatus
          class="align-self-center"
          :is-hris-profile="isHrisProfile"
          :is-archived="profile.is_archived"
        />
        <JobProfileMeta
          class="align-self-center"
          :profile="profile"
        />
        <v-spacer />
        <v-btn
          v-show="hovered"
          icon
          variant="text"
          size="x-small"
          class="ml-2 flex-shrink-0"
          :title="isHrisProfile ? 'Remove link to Workday source profile' : 'Remove link to draft profile'"
          @click.prevent="onUnlink"
        >
          <v-icon
            size="16"
            icon="mdi-link-off"
          />
        </v-btn>
      </v-sheet>
    </v-card>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useModals } from '@/stores/modals/modals';
import JobProfileMeta from '@/components/jobProfiles/editor/JobProfileMeta.vue';
import JobProfileStatus from '@/components/jobProfiles/editor/JobProfileStatus.vue';

const props = defineProps({
  profile: {
    type: Object,
    required: true,
  },
  isHrisProfile: {
    type: Boolean,
    default: false,
  },
});

const { setModal } = useModals();
const hovered = ref(false);

const onUnlink = () => {
  setModal({
    field: 'unlinkHrisProfileConfirm',
    value: true,
    params: props.isHrisProfile ? {} : { draftProfile: props.profile },
  });
};
</script>

<style lang="less" scoped>
.v-card {
  border-color: @stroke-default;
}
</style>
